import { render, staticRenderFns } from "./fileMessage.vue?vue&type=template&id=08d4f157&scoped=true&"
import script from "./fileMessage.vue?vue&type=script&lang=js&"
export * from "./fileMessage.vue?vue&type=script&lang=js&"
import style0 from "./fileMessage.vue?vue&type=style&index=0&id=08d4f157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4f157",
  null
  
)

export default component.exports